import I18N from '@leverege/i18n';
import { Relationship } from '@leverege/ui-attributes';
export default class OpenApiRelationship extends Relationship {
  constructor(opts, calc) {
    super({
      ...opts,
      parent: true
    }, calc);
    this.opts = opts;
    this.blueprint = opts.blueprint;
    this.tags = opts.tags ?? [];
    this.i18n = I18N.ns(`openApi.${this.apiName}.relationship.${this.path.split('.').join('/')}`);
  }
  set options(val) {
    this._whoCares = val;
  }
  get options() {
    return this.opts ? {
      ...this.opts,
      isGroup: this.opts.isGroup ?? this.opts.relationshipType !== 'oneToOne',
      idKey: this.opts.idKey || this.blueprint.idKey
    } : this._whoCares;
  }
  get id() {
    if (this.isGroup && !this.isItem) {
      return null;
    }
    if (this.calc.id == null && this.calc.match) {
      if (this.isGroup) {
        this.calc.id = this.calc.match.params?.[this.options.idKey];
      } else {
        this.calc.id = this.subpath ?? this.calc.match.params?.[this.options.idKey];
      }
    }
    return this.calc.id;
  }
  get objRefUrlPath() {
    if (this.options.objRefUrlPath == null) {
      const key = this.isGroup ? `:${this.options.idKey}` : this.subpath;
      return `${this.refPath}/${key}`;
    }
    return this.options.objRefUrlPath;
  }
  getIcon(key) {
    return this.blueprint.getIcon(key);
  }
  get name() {
    return this.i18n.t('name', this.blueprint.name, {
      count: this.isItem ? 1 : 0
    });
  }
  get supportsCreate() {
    const {
      api
    } = this.options;
    return !this.isItem && api.supports(this.urlPath, 'post');
  }
  get supportsRead() {
    const {
      api
    } = this.options;
    return this.isItem && api.supports(this.urlPath, 'get');
  }
  get supportsUpdate() {
    const {
      api
    } = this.options;
    return this.isItem && api.supports(this.urlPath, 'patch');
  }
  get supportsDelete() {
    const {
      api
    } = this.options;
    return this.isItem && api.supports(this.urlPath, 'delete');
  }
  get supportsList() {
    const {
      api
    } = this.options;
    return !this.isItem && api.supports(this.urlPath, 'get');
  }

  /**
   * Returns true if the tags include the specified tab
   */
  hasTag(tag) {
    return this.tags.includes(tag);
  }

  /**
     * Returns the first tag starting with the prefix
     * If strip is true, this will return the value of the 
     * tag after the prefix
     */
  getTagStartingWith(prefix, strip) {
    const arr = this.tags;
    if (arr == null) {
      return null;
    }
    const val = arr.find(t => t.startsWith(prefix));
    if (val && strip) {
      return val.substring(prefix.length);
    }
    return val;
  }

  /**
     * Returns all tags starting with the prefix
     * If strip is true, this will return the value of the 
     * tag after the prefix
     */
  getTagsStartingWith(prefix, strip) {
    let arr = this.tags;
    if (arr == null) {
      return [];
    }
    arr = arr.filter(t => t.startsWith(prefix));
    if (arr.length > 0 && strip) {
      return arr.map(val => val.substring(prefix.length));
    }
    return arr;
  }
  getString = (strName, defaultValue) => {
    return this.i18n.t(strName, defaultValue);
  };
  get attribute() {
    return {
      name: this.getString('name')
    };
  }
  get containingGroup() {
    return new OpenApiRelationship({
      ...this.opts,
      isGroup: true,
      isItem: false,
      urlPath: this.urlPath.split('/').slice(0, -1).join('/')
    });
  }
}